import { render } from "./infoPop.vue?vue&type=template&id=6e770772&scoped=true"
import script from "./infoPop.vue?vue&type=script&lang=js"
export * from "./infoPop.vue?vue&type=script&lang=js"

import "./infoPop.vue?vue&type=style&index=0&id=6e770772&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e770772"

export default script